/**
 * Helpers puros usados por WaMessageRow (1023 LOC) y testeables sin DOM.
 *
 * Extraídos del componente principal para poder cubrirlos con tests
 * unitarios. NO depender de React aquí — son funciones puras.
 */

// Paleta tipo WhatsApp Web (8 colores). Los participantes de un grupo
// reciben un color estable basado en hash de su seed (phone o JID).
const GROUP_COLORS = [
  '#06cf9c', // verde
  '#53bdeb', // azul claro
  '#e57373', // rojo claro
  '#9575cd', // violeta
  '#f06292', // rosa
  '#ffb74d', // naranja
  '#4db6ac', // teal
  '#7986cb', // azul-violeta
] as const;

/**
 * Asigna un color de la paleta al participant seed.
 *
 * Propiedad CRÍTICA: para el mismo `seed`, retorna SIEMPRE el mismo color.
 * Esto permite que cada participante del grupo se vea consistentemente con
 * el mismo color en toda la app (mismo patrón que WhatsApp Web).
 *
 * Fallback: si `seed` es null/empty, retorna el primer color de la paleta.
 */
export function groupParticipantColor(seed: string | null | undefined): string {
  if (!seed) return GROUP_COLORS[0];
  let h = 0;
  for (let i = 0; i < seed.length; i++) h = (h * 31 + seed.charCodeAt(i)) >>> 0;
  return GROUP_COLORS[h % GROUP_COLORS.length];
}

/**
 * Construye iniciales para mostrar como avatar fallback cuando no hay
 * foto de perfil del participante.
 *
 * Reglas:
 *   - null/empty → '?'
 *   - 1 palabra  → primeras 2 letras en mayúscula
 *   - 2+ palabras → primera letra de la primera + primera letra de la última
 */
export function groupParticipantInitials(name: string | null | undefined): string {
  if (!name) return '?';
  const parts = name.trim().split(/\s+/).filter(Boolean);
  if (parts.length === 0) return '?';
  if (parts.length === 1) return parts[0].slice(0, 2).toUpperCase();
  return (parts[0][0] + parts[parts.length - 1][0]).toUpperCase();
}

// Exposición de la paleta para tests + uso compartido.
export { GROUP_COLORS };
